export const orderedSizesArray = [
    'UNICA',
    '3YXS',
    '2YXS',
    'YXS',
    'XXS',
    'XXS/XS',
    'XS',
    'XS/S',
    'S',
    'S/M',
    'M',
    'M/L',
    'L',
    'L/XL',
    'XL',
    'XL/XXL',
    'XXL',
    '2XL/3XL',
    'XXXL',
    '4XL',
    '5XL',
    '3',
    '4',
    '5',
    '6',
    '6.5',
    '7',
    '7.5',
    '8',
    '8.5',
    '9',
    '9.5',
    '10',
    '10.5',
    '11',
    '32',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    'K26',
];


export const orderTypesData = [
    {
        '@odata.etag': 'W/"JzIwOzExNzI5NDk2NjM1NTI2MjM5ODU4MTswMDsn"',
        type: 'Order Type',
        code: 'PROMO',
        description: 'Promozionale',
        filterValue: '',
        lastModifiedDateTime: '0001-01-01T00:00:00Z',
    },
    {
        '@odata.etag': 'W/"JzE5OzM1NDk5MTgyMzg5MTc1NzkyMjkxOzAwOyc="',
        type: 'Order Type',
        code: 'VENDI',
        description: 'Vendita',
        filterValue: '',
        lastModifiedDateTime: '0001-01-01T00:00:00Z',
    },
    {
        '@odata.etag': 'W/"JzE5OzM1NDk5MTgyMzg5MTc1NzkyMjkxOzAwOyc="',
        type: 'Order Type',
        code: 'CAMPI',
        description: 'Campionario',
        filterValue: '',
        lastModifiedDateTime: '0001-01-01T00:00:00Z',
    },
    {
        '@odata.etag': 'W/"JzE5OzM1NDk5MTgyMzg5MTc1NzkyMjkxOzAwOyc="',
        type: 'Order Type',
        code: 'CRIP',
        description: 'Conto Riparazione',
        filterValue: '',
        lastModifiedDateTime: '0001-01-01T00:00:00Z',
    },
    {
        '@odata.etag': 'W/"JzE5OzM1NDk5MTgyMzg5MTc1NzkyMjkxOzAwOyc="',
        type: 'Order Type',
        code: 'SPONS',
        description: 'Sponsor',
        filterValue: '',
        lastModifiedDateTime: '0001-01-01T00:00:00Z',
    },
];

export const legacyIconClassPrefix = 'icon errea-';

export const iconClassPrefix = 'svgfont-';

export const brochureMinOrderQuantity = 2;

export const brochureCartHash = 'brochure';

// TODO: Remove or set to true when Zakeke attributes will work properly
export const enableZakekeAttributes = true;

// TODO: Confirm stock check removal
export const enableBrochureStockCheck = false;